import { resolveHref } from 'next/dist/client/resolve-href';
import { Url } from 'next/dist/shared/lib/router/router';
import Router from 'next/router';

import { LinkFragmentFragment } from '../__generated__/graphql';

const origins = [
  'https://h3jwu5boo65ki8up1x3hat0qy.js.wpenginepowered.com', // dev
  'https://triumphiodev.wpenginepowered.com', // dev
  'https://hcid1heo0p7xge87s47thwxu4.js.wpenginepowered.com', // staging
  'https://triumphiostg.wpenginepowered.com', // staging
  'https://triumphio.wpenginepowered.com', // production
  'https://www.triumph.io', // production
  'https://triumph.io', // production
  'https://static.triumph.io', // production
];

const hasFileExtension = (href: string) => {
  const fileExtensions = [
    '.csv',
    '.doc',
    '.docx',
    '.pdf',
    '.ppt',
    '.pptx',
    '.txt',
    '.xls',
    '.xlsx',
    '.zip',
  ];

  return fileExtensions.some(ext => href.toLowerCase().endsWith(ext));
};

export const convertHref = (url: LinkFragmentFragment['url'] | Url) => {
  if (!url) {
    return '';
  }

  const href = typeof url === 'object'
    ? resolveHref(Router, url as Url)
    : url;

  if (hasFileExtension(href)) {
    return href;
  }

  if (href.startsWith('/')) {
    return href;
  }

  try {
    const hrefUrl = new URL(href);

    if (origins.includes(hrefUrl.origin)) {
      return href.replace(hrefUrl.origin, '');
    }
  }
  catch {
    // Ignore error
    return href;
  }

  return href;
};
